import React from "react";

/**
 * Restaurant Marker Component for showing restaurant location
 */
const RestaurantMarker = ({ t }) => {
  if (!t) {
    return null;
  }

  return (
    <div
      className="relative transform hover:scale-110 transition-transform duration-200"
      style={{
        width: "32px",
        height: "32px",
      }}
      title={t("scheduleMap.restaurantLocation")}
    >
      {/* Restaurant building icon */}
      <div
        className="flex items-center justify-center"
        style={{
          width: "32px",
          height: "32px",
          backgroundColor: "#059669", // Green-600
          borderRadius: "50%",
          border: "3px solid white",
          boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
        }}
      >
        <svg
          className="w-4 h-4 text-white"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fillRule="evenodd"
            d="M4 4a2 2 0 00-2 2v8a2 2 0 002 2V4zm2 0h8a2 2 0 012 2v8a2 2 0 01-2 2V4zM6 6h2v2H6V6zm0 4h2v2H6v-2zm0 4h2v2H6v-2zm4-8h2v2h-2V6zm0 4h2v2h-2v-2zm0 4h2v2h-2v-2z"
            clipRule="evenodd"
          />
        </svg>
      </div>
      {/* Restaurant label */}
      <div
        className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 px-2 py-1 bg-green-600 text-white text-xs rounded whitespace-nowrap"
        style={{
          fontSize: "10px",
          fontWeight: "500",
        }}
      >
        {t("scheduleMap.restaurant")}
      </div>
    </div>
  );
};

export default RestaurantMarker;
